import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { Breadcrumbs, Footer, HeaderVertical } from '../../containers';
import ButtonFontSize from '../../containers/ButtonAccesibility';
import ScrollToTop from '../../components/ScrollToTop';

const useStyles = makeStyles((theme) => ({
  backgroundDefault: {
    background: `${theme.palette.background.default}`,
  },
}));

interface ILayoutPrincipalProps {
  themeSelected: string;
  onChangeTheme: (theme: string) => void;
  onChangeStatusAuth: (token: string) => void;
  onChangeFontSize: (more: boolean) => void;
  onOpenLogin: () => void;
  children: React.ReactNode;
}

const LayoutPrincipal = ({
  children,
  themeSelected,
  onChangeTheme,
  onChangeStatusAuth,
  onChangeFontSize,
  onOpenLogin,
}: ILayoutPrincipalProps) => {
  const classes = useStyles();

  return (
    <div className='min-h-screen'>
      <div className={clsx(classes.backgroundDefault, 'flex flex-col')}>
        <HeaderVertical
          onChangeTheme={onChangeTheme}
          onChangeStatusAuth={onChangeStatusAuth}
          themeSelected={themeSelected}
          onOpenLogin={onOpenLogin}
        >
          <Breadcrumbs />
          <main className='mb-40'>{children}</main> 
          <Footer />
          <ButtonFontSize
            onChangeSize={onChangeFontSize}
            onChangeTheme={onChangeTheme}
            themeSelected={themeSelected}
          />
          <ScrollToTop />
        </HeaderVertical>
        <br />
        <br />
        <br />
      </div>
      <div></div>
    </div>
  );
};
export default LayoutPrincipal;
